import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import productPricingTierService from '../../services/productPricingTier';

export const fetchProductPricingTiers = createAsyncThunk(
  'productPricingTier/fetchProductPricingTiers',
  async (params = {}) => {
    const res = await productPricingTierService.get(params);
    return res;
  },
);

export const fetchProductPricingTierByName = createAsyncThunk(
  'productPricingTier/fetchByName',
  async (name, { rejectWithValue }) => {
    try {
      const res = await productPricingTierService.getByName(name);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch pricing tier by name',
      );
    }
  },
);

const productPricingTierSlice = createSlice({
  name: 'productPricingTier',
  initialState: {
    productPricingTiers: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductPricingTiers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductPricingTiers.fulfilled, (state, action) => {
        console.log('API response payload:', action);
        state.productPricingTiers = action.payload;
        state.loading = false;
      })
      .addCase(fetchProductPricingTiers.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchProductPricingTierByName.pending, (state) => {
        state.loading = true;
        state.tierDetail = null;
      })
      .addCase(fetchProductPricingTierByName.fulfilled, (state, action) => {
        console.log('Fetched tier by name:', action.payload);
        state.tierDetail = action.payload || null;
        state.loading = false;
      })
      .addCase(fetchProductPricingTierByName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default productPricingTierSlice.reducer;
